module.exports = __webpack_public_path__ + "img/doc.0fcd8654.png";